import { useNavigate, useLocation } from "react-router-dom";

function BackButton({ to, label, section }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (to) {
      if (to === "/settings" && section) {
        navigate(to, { state: { openSection: section, from: location.pathname } });
      } else {
        navigate(to);
      }
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="settings-back-btn"
    >
      <i className="fas fa-arrow-left" />
      <span>{label || "Back"}</span>
    </button>
  );
}

export default BackButton;
